import { createActions } from 'redux-actions';
import * as types from 'actions/auth/types';

export default createActions({}, ...Object.values(types));
